import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { installStaleChunkRecovery } from "./components/app/staleChunkRecovery";

// Fora da árvore do React de propósito: precisa valer mesmo se o app desmontar.
installStaleChunkRecovery();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
